import React, { Component } from 'react';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import authService from './AuthorizeService';
import AuthenticatedOptions from "./components/Authenticated";
import UnauthenticatedOptions from "./components/Unauthenticated";

export class LoginMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      userName: null,
      loading: false
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState({
      isAuthenticated,
      userName: user && user.name
    });
  }

  render() {
    const { isAuthenticated, userName } = this.state;
    if (!isAuthenticated) {
      const registerPath = `${ApplicationPaths.Register}`;
      const loginPath = `${ApplicationPaths.Login}`;
      return this.anonymousView(registerPath, loginPath);
    } else {
      const profilePath = `${ApplicationPaths.Profile}`;
      const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
      return this.authenticatedView(userName, profilePath, logoutPath);
    }
  }

  authenticatedView(userName, profilePath, logoutPath) {
    return <AuthenticatedOptions logoutPath={logoutPath} profilePath={profilePath} />;
  }

  anonymousView(registerPath, loginPath) {
    return <UnauthenticatedOptions registerPath={registerPath} loginPath={loginPath} />;
  }
}
